import { Button, VStack } from '@fhs-legacy/universal-components';

export const IconContainer = Button.withConfig({
  variant: 'ghost',
});

export const CartItems = VStack;
